import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { dashboardComponent } from './dashboard/dash-component';
import { pubprofileComponent } from './myProfile/profile-component';
import { offersComponent } from './offers/offers-component';
import { offerDetailsComponent } from './offers/offer-details/offer-details-component';
import { paymentsComponent } from './payments/payments-component';
// import { campaignsComponent } from './campaigns/offers-component';

import { fileListComponent } from './lockers/files/files-list';
import { contentsComponent } from './lockers/content/content-component';
import { conversionsComponent } from './analytics/conversions/conv-component';
// import { contentsComponent } from './analytics/contents/contents-component';
import { contentNewComponent } from './lockers/content-new/content-new';
// import { analCountriesComponent } from './analytics/countries/count-component';
import { analworldmapComponent } from './analytics/liveview/worldmap';
import { analyticsComponent } from './analytics/analytics/analytics';
import { contentEditComponent } from './lockers/content-edit/content-edit';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'dashboard',
        component: dashboardComponent,
        data: {
          //title: "Dashobard",
          breadcrumb: "Dashboard"
        }
      },
      {
        path: 'profile',
        component: pubprofileComponent,
        data: {
          // title: "My profile",
          breadcrumb: "My profile"
        }
      },
      {
        path: 'payments',
        component: paymentsComponent,
        data: {
          // title: "Payments",
          breadcrumb: "Payments"
        }
      },
      {
        path: 'offers',
        component: offersComponent,
        data: {
          // title: "Campaigns",
          breadcrumb: "Offers"
        }
      },
      {
        path: 'offers/:id',
        component: offerDetailsComponent,
        data: {
          // title: "Campaigns",
          breadcrumb: "Offers / Offer detail"
        }
      },
      {
        path: 'files',
        component: fileListComponent ,
        data: {
          // title: "Files locker",
          breadcrumb: "Files Lockers"
        }
      },
      {
        path: 'gateways',
        component:  contentsComponent,
        data: {
          // title: "Gateway locker",
          breadcrumb: "Content Lockers"
        }
      },
      {
        path: 'gateway/:id',
        component:  contentEditComponent,
        data: {
          // title: "Gateway edit",
          breadcrumb: "Content Lockers / Edit"
        }
      },
      {
        path: 'gatewaynew',
        component:  contentNewComponent,
        data: {
          // title: "Gateway new",
          breadcrumb: "Content Lockers / New"
        }
      },
      {
        path: 'conversions',
        component:  conversionsComponent,
        data: {
          // title: "Conversions statistics",
          breadcrumb: "Stats / conversions"
        }
      },
      // {
      //   path: 'contents',
      //   component:  contentsComponent ,
      //   data: {
      //     // title: "Contents statistics",
      //     breadcrumb: "Stats / contents"
      //   }
      // },
      // {
      //   path: 'countries',
      //   component:  analCountriesComponent ,
      //   data: {
      //     // title: "Countries statistics",
      //     breadcrumb: "Stats / countries"
      //   }
      // },
      {
        path: 'analytics',
        component:  analyticsComponent ,
        data: {
          // title: "Countries statistics",
          breadcrumb: "Stats / analytics"
        }
      },
      {
        path: 'worldmap',
        component:  analworldmapComponent ,
        data: {
          // title: "Countries statistics",
          breadcrumb: "Stats / world map"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PubRoutingModule { }
